export default "__VITE_ASSET__dOKb9rgg__"